"use client";

import { useCart } from "./providers/CartProvider";

export default function Cartcount() {
  const { count, reloadCart } = useCart();
  return(<span className="bigfont">{count}</span>);
}

